interface AddressResponse {
    building?: string;
    apartment?: string;
    makani?: string;
    streetName?: string;
    streetNumber?: string;
    area?: string;
    landmark?: string;
    city?: string;
    zoneNumber?: string;
    postalCode?: string;
    countryIsoCode?: string;
}

export const getFormattedAddressForShipping = (response: AddressResponse) => {
        const fields = [
            response?.building,       // Building
            response?.apartment,      // Apartment
            response?.makani,         // Makani 
            response?.streetName,     // Street Name
            response?.streetNumber,   // street number 
            response?.area,           // Area
            response?.landmark,       // Landmark 
            response?.city,           // City
            response?.zoneNumber,     // zone
            response?.postalCode,     //postal code
        ];

        // Filter out any undefined, null, or empty fields and join with newlines
        // Add LRM (Left-to-Right Mark) to maintain correct sequence with Arabic text
        return fields.filter(field => field && field.trim() !== "").map(field => `\u200E${field}`).join(", ");
    };